var _window_appSystemInfo;
import { defineComponent, defineAsyncComponent, provide, onMounted, onUnmounted, ref } from 'vue';
import { Auth, Device, Env } from '@nio-pow/mfe-vue3';
import './assets/styles/global.scss';
import { AUTH_WHITELIST } from '@/utils/constants';
import envConfig from '@/utils/envConfig';
import Layout from '@/components/Layout/index.vue';
// 悬浮球拖着整棵 copilot 依赖树（@copilotkit/*、mermaid、shiki 等，约 5MB，
// 含低版本 iOS 不兼容的语法/API，为线上白屏根因），必须异步按需加载：
// - 模板须用 <component :is> 而非 <AssistantBall />：unplugin-vue-components
//   扫描 src/components，会把组件标签在编译期改写回静态 import，异步化失效
// - v-if 门控：球默认关闭，未开启或无 AGI 网关（EU 部署）时不加载 chunk
const BALL_ENABLE_KEY = 'agui-assistant-ball' // 与 AssistantBall.vue / 助手页设置同 key
;
const hasAgiGateway = Boolean(envConfig.AGI_API);
const AssistantBall = defineAsyncComponent(()=>import('@/components/AssistantBall.vue'));
// 初始化语言包 & 版本
const lang = Env.getLang();
const appType = Env.getAppType();
const container = ((_window_appSystemInfo = window.appSystemInfo) === null || _window_appSystemInfo === void 0 ? void 0 : _window_appSystemInfo.container) || 'browser';
document.body.setAttribute('lang', lang);
document.body.setAttribute('data-app-type', appType);
document.body.setAttribute('data-container', container);
export default defineComponent({
    name: 'AppRootPage',
    components: {
        Layout
    },
    computed: {
        isMicroApp () {
            const { isMicroApp } = this.$route.meta || {};
            return typeof isMicroApp === 'boolean' ? isMicroApp : false;
        },
        isWhiteListPage () {
            return AUTH_WHITELIST.includes(window.location.pathname);
        }
    },
    setup () {
        const user = ref();
        provide('isMobile', Device.isMobile());
        provide('appInfo', {
            lang,
            appType
        });
        const getUserRes = async ()=>{
            try {
                const userRes = await Auth.initUserInfoWithCacheMode();
                const { userId } = (userRes === null || userRes === void 0 ? void 0 : userRes.data) || {};
                if (userId) {
                    user.value = userId;
                }
            } catch (error) {
                console.error(error);
            }
        };
        // 悬浮球开关门控：与 AssistantBall 内部共用同一 localStorage key，
        // 助手页设置弹窗变更时通过 agui-assistant-ball-change / storage 事件广播
        const ballEnabled = ref(localStorage.getItem(BALL_ENABLE_KEY) === '1');
        const syncBallEnabled = ()=>{
            ballEnabled.value = localStorage.getItem(BALL_ENABLE_KEY) === '1';
        };
        onMounted(()=>{
            if (!AUTH_WHITELIST.includes(window.location.pathname)) {
                getUserRes();
            }
            window.addEventListener('agui-assistant-ball-change', syncBallEnabled);
            window.addEventListener('storage', syncBallEnabled);
        });
        onUnmounted(()=>{
            window.removeEventListener('agui-assistant-ball-change', syncBallEnabled);
            window.removeEventListener('storage', syncBallEnabled);
        });
        return {
            user,
            ballEnabled,
            hasAgiGateway,
            AssistantBall
        };
    }
});
